import {NavLink, useLocation} from "react-router-dom";
import {Box} from "@mui/material";

import {desktopNavStyles} from './desktopNav-helpers';
import {navLinks} from '../../navLinks';

export const DesktopNav = () => {
    const {pathname} = useLocation();

    return (
        <Box sx={desktopNavStyles.navBarWrapper}>
            {navLinks.map((nav) => {
                const isActive: boolean =
                    pathname === nav.path ||
                    pathname.startsWith(`${nav.path}/`) ||
                    !!nav.aliases?.includes(pathname);

                return (
                    <NavLink key={nav.path} to={nav.path} style={() => desktopNavStyles.navLink(isActive)}>
                        {nav.label}
                    </NavLink>
                );
            })}
        </Box>
    );
};
